var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_2560",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_2560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 58.3333V21.6667H27.7779V25H52.2221V21.6667H55V58.3333H52.2221V55H27.7779V58.3333H25ZM27.7779 38.6388H31.9446V31.9721H41.3888V38.6388H52.2221V27.7779H27.7779V38.6388ZM27.7779 52.2221H38.6113V45.5554H48.0554V52.2221H52.2221V41.4167H27.7779V52.2221ZM34.7221 38.6388H38.6113V34.75H34.7221V38.6388ZM41.3888 52.2221H45.2779V48.3333H41.3888V52.2221Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowInventory);
export default __webpack_public_path__ + "static/media/icon-flow-inventory.376eebd277f2ac7bf6129e8967d49710.svg";
export { ForwardRef as ReactComponent };